import React from "react";
import { Select } from "antd";

const DropDown = (props) => {
  const sourceData = props?.data || props?.option || [];

  const options = sourceData.map((data, index) => (
    <Select.Option
      key={index}
      disabled={data?.disabled}
      value={data?.value ?? data?.id ?? data}
    >
      {data?.label || data?.name || data}
    </Select.Option>
  ));

  const handleChange = (val) => {
    // CLEAR
    if (!val || (Array.isArray(val) && val.length === 0)) {
      props.onChange(props.mode === "multiple" ? [] : undefined);
      return;
    }

    // MULTIPLE
    if (props.mode === "multiple") {
      if (props.enableSelectAll && val.includes("ALL")) {
        const allValues = sourceData
          .filter((d) => d?.value !== "ALL")
          .map((d) => d?.value ?? d?.id ?? d);

        props.onChange(allValues);
        return;
      }

      props.onChange(val);
      return;
    }

    // SINGLE
    props.onChange(val);
  };

  return (
    <Select
      mode={props.mode}
      placeholder={props.placeholder}
      value={props.value}
      allowClear={props.allowClear}
      onChange={handleChange}
      onClear={props.onClear}   // ✅ IMPORTANT
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
      className={props.className}
      disabled={props.disabled}
    >
      {options}
    </Select>
  );
};

export default DropDown;
